import { render, staticRenderFns } from "./canteenClass.vue?vue&type=template&id=7a20a786&"
import script from "./canteenClass.vue?vue&type=script&lang=js&"
export * from "./canteenClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports